module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "g-mt-minus-70",
    class: [{
      'container-fluid': this.framePageVisible == 'true'
    }, {
      'container-fluid': _vm.accountType != 'master'
    }, {
      'container': this.framePageVisible == 'false'
    }]
  }, [_c('div', {
    staticClass: "row"
  }, [(this.framePageVisible == 'true' || _vm.accountType == 'master') ? _c('div', {
    staticClass: "col-lg-1 col-div-0"
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 g-mb-30 g-mb-20--lg",
    class: [{
      'col-lg-2 col-div-4': this.framePageVisible == 'true'
    }, {
      'col-lg-2 col-div-4': _vm.accountType == 'master'
    }, {
      'col-lg-3': this.framePageVisible == 'false'
    }]
  }, [_c('div', {
    staticClass: "g-py-10 g-icon-link",
    on: {
      "click": function($event) {
        return _vm.RouterRedirect('Order')
      }
    }
  }, [_c('div', {
    staticClass: "u-shadow-v37 rounded-circle g-pos-rel mx-auto",
    class: [{
      'g-width-200 g-height-200': this.framePageVisible == 'true'
    }, {
      'g-width-200 g-height-200': _vm.accountType == 'master'
    }, {
      'g-width-220 g-height-220': this.framePageVisible == 'false'
    }]
  }, [_c('svg', {
    attrs: {
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "x": "0px",
      "y": "0px",
      "viewBox": "0 0 187 187",
      "enable-background": "new 0 0 187 187",
      "xml:space": "preserve"
    }
  }, [_c('g', {
    attrs: {
      "id": "_x31_"
    }
  }, [_c('circle', {
    attrs: {
      "fill": "#ffffff",
      "cx": "93.5",
      "cy": "93.5",
      "r": "93.5"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "fill": "#ffffff",
      "stroke": "#f0f2f8",
      "stroke-width": "7",
      "stroke-miterlimit": "10",
      "cx": "93.5",
      "cy": "93.5",
      "r": "81"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "fill": "none",
      "stroke": "var(--primary-color)",
      "stroke-width": "7",
      "stroke-linecap": "round",
      "stroke-miterlimit": "10",
      "d": "M93.5,12.5c26.7,0,50.4,12.9,65.2,32.9"
    }
  })])]), _vm._v(" "), _vm._m(0)])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 g-mb-30 g-mb-20--lg",
    class: [{
      'col-lg-2 col-div-4': this.framePageVisible == 'true'
    }, {
      'col-lg-2 col-div-4': _vm.accountType === 'master'
    }, {
      'col-lg-3': this.framePageVisible == 'false'
    }]
  }, [_c('div', {
    staticClass: "g-py-10 g-icon-link",
    on: {
      "click": function($event) {
        return _vm.RouterRedirect('OrderTracking')
      }
    }
  }, [_c('div', {
    staticClass: "u-shadow-v37 rounded-circle g-pos-rel mx-auto",
    class: [{
      'g-width-200 g-height-200': this.framePageVisible == 'true'
    }, {
      'g-width-200 g-height-200': _vm.accountType === 'master'
    }, {
      'g-width-220 g-height-220': this.framePageVisible == 'false'
    }]
  }, [_c('svg', {
    attrs: {
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "x": "0px",
      "y": "0px",
      "viewBox": "0 0 187 187",
      "enable-background": "new 0 0 187 187",
      "xml:space": "preserve"
    }
  }, [_c('circle', {
    attrs: {
      "fill": "#ffffff",
      "cx": "93.5",
      "cy": "93.5",
      "r": "93.5"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "fill": "#ffffff",
      "stroke": "#f0f2f8",
      "stroke-width": "7",
      "stroke-miterlimit": "10",
      "cx": "93.5",
      "cy": "93.5",
      "r": "81"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "fill": "none",
      "stroke": "var(--primary-color)",
      "stroke-width": "7",
      "stroke-linecap": "round",
      "stroke-miterlimit": "10",
      "d": "M93.5,12.5\n                c43,0,78.2,33.6,80.8,75.9"
    }
  })]), _vm._v(" "), _vm._m(1)])])]), _vm._v(" "), (this.framePageVisible == 'true' || _vm.accountType == 'master') ? _c('div', {
    staticClass: "col-sm-6 col-lg-2 col-div-4 g-mb-30 g-mb-20--lg"
  }, [_c('div', {
    staticClass: "g-py-10 g-icon-link",
    on: {
      "click": function($event) {
        return _vm.RouterRedirect('FramesCenter')
      }
    }
  }, [_c('div', {
    staticClass: "u-shadow-v37 rounded-circle g-pos-rel mx-auto",
    class: [{
      'g-width-200 g-height-200': this.framePageVisible == 'true'
    }, {
      'g-width-200 g-height-200': _vm.accountType == 'master'
    }, {
      'g-width-220 g-height-220': this.framePageVisible == 'false'
    }]
  }, [_c('svg', {
    attrs: {
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "x": "0px",
      "y": "0px",
      "viewBox": "0 0 187 187",
      "enable-background": "new 0 0 187 187",
      "xml:space": "preserve"
    }
  }, [_c('circle', {
    attrs: {
      "fill": "#ffffff",
      "cx": "93.5",
      "cy": "93.5",
      "r": "93.5"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "fill": "#ffffff",
      "stroke": "#f0f2f8",
      "stroke-width": "7",
      "stroke-miterlimit": "10",
      "cx": "93.5",
      "cy": "93.5",
      "r": "81"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "fill": "none",
      "stroke": "var(--primary-color)",
      "stroke-width": "7",
      "stroke-linecap": "round",
      "stroke-miterlimit": "10",
      "d": "M93.5,12.5c44.7,0,81,36.3,81,81c0,21.3-8.2,40.6-21.6,55.1,55"
    }
  })]), _vm._v(" "), _vm._m(2)])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 g-mb-30 g-mb-20--lg",
    class: [{
      'col-lg-2 col-div-6': this.framePageVisible == 'true'
    }, {
      'col-lg-2 col-div-6': _vm.accountType == 'master'
    }, {
      'col-lg-3': this.framePageVisible == 'false'
    }]
  }, [_c('div', {
    staticClass: "g-py-10 g-icon-link",
    class: [{
      'div-left': this.framePageVisible == 'true'
    }, {
      'div-left': _vm.accountType == 'master'
    }],
    on: {
      "click": function($event) {
        return _vm.RouterRedirect('Resource')
      }
    }
  }, [_c('div', {
    staticClass: "u-shadow-v37 rounded-circle g-pos-rel mx-auto",
    class: [{
      'g-width-200 g-height-200': this.framePageVisible == 'true'
    }, {
      'g-width-200 g-height-200': _vm.accountType == 'master'
    }, {
      'g-width-220 g-height-220': this.framePageVisible == 'false'
    }]
  }, [_c('svg', {
    attrs: {
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "x": "0px",
      "y": "0px",
      "viewBox": "0 0 187 187",
      "enable-background": "new 0 0 187 187",
      "xml:space": "preserve"
    }
  }, [_c('circle', {
    attrs: {
      "fill": "#ffffff",
      "cx": "93.5",
      "cy": "93.5",
      "r": "93.5"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "fill": "#ffffff",
      "stroke": "#f0f2f8",
      "stroke-width": "7",
      "stroke-miterlimit": "10",
      "cx": "93.5",
      "cy": "93.5",
      "r": "81"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "fill": "none",
      "stroke": "var(--primary-color)",
      "stroke-width": "7",
      "stroke-linecap": "round",
      "stroke-miterlimit": "10",
      "d": "M93.5,12.5c44.7,0,81,36.3,81,81s-36.3,81-81,81c-26.3"
    }
  })]), _vm._v(" "), _vm._m(3)])])]), _vm._v(" "), _c('div', {
    staticClass: "g-mb-30 g-mb-20--lg",
    class: [{
      'col-sm-12 col-lg-2 col-div-6': this.framePageVisible == 'true'
    }, {
      'col-sm-12 col-lg-2 col-div-6': _vm.accountType == 'master'
    }, {
      'col-sm-6 col-lg-3': this.framePageVisible == 'false'
    }]
  }, [_c('div', {
    staticClass: "g-py-10 g-icon-link",
    class: [{
      'div-right': this.framePageVisible == 'true'
    }, {
      'div-right': _vm.accountType == 'master'
    }],
    on: {
      "click": function($event) {
        return _vm.RouterRedirect('Help')
      }
    }
  }, [_c('div', {
    staticClass: "u-shadow-v37 rounded-circle g-pos-rel mx-auto",
    class: [{
      'g-width-200 g-height-200': this.framePageVisible == 'true'
    }, {
      'g-width-200 g-height-200': _vm.accountType == 'master'
    }, {
      'g-width-220 g-height-220': this.framePageVisible == 'false'
    }]
  }, [_c('svg', {
    attrs: {
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "x": "0px",
      "y": "0px",
      "viewBox": "0 0 187 187",
      "enable-background": "new 0 0 187 187",
      "xml:space": "preserve"
    }
  }, [_c('circle', {
    attrs: {
      "fill": "#ffffff",
      "cx": "93.5",
      "cy": "93.5",
      "r": "93.5"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "fill": "#ffffff",
      "stroke": "#f0f2f8",
      "stroke-width": "7",
      "stroke-miterlimit": "10",
      "cx": "93.5",
      "cy": "93.5",
      "r": "81"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "fill": "#ffffff",
      "stroke": "var(--primary-color)",
      "stroke-width": "7",
      "stroke-linecap": "round",
      "stroke-miterlimit": "10",
      "d": "M93.5,12.5\n                c44.7,0,81,36.3,81,81s-36.3,81-81,81c-26.3,0-49.7-12.6-64.5-32"
    }
  })]), _vm._v(" "), _vm._m(4)])])]), _vm._v(" "), (this.framePageVisible == 'true' || _vm.accountType == 'master') ? _c('div', {
    staticClass: "col-lg-1 col-div-0"
  }) : _vm._e()])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text-center g-absolute-centered--y g-left-0 g-right-0 g-px-35"
  }, [_c('h4', {
    staticClass: "h2 g-font-primary"
  }, [_vm._v("Patient Order")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text-center g-absolute-centered--y g-left-0 g-right-0 g-px-35"
  }, [_c('h4', {
    staticClass: "h2 g-font-primary"
  }, [_vm._v("Track Order")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text-center g-absolute-centered--y g-left-0 g-right-0 g-px-35"
  }, [_c('h4', {
    staticClass: "h2 g-font-primary nomargin"
  }, [_vm._v("Frame Collection")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text-center g-absolute-centered--y g-left-0 g-right-0 g-px-35"
  }, [_c('h4', {
    staticClass: "h2 g-font-primary"
  }, [_vm._v("Guides & Resources")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text-center g-absolute-centered--y g-left-0 g-right-0 g-px-35"
  }, [_c('h4', {
    staticClass: "h2 g-font-primary"
  }, [_vm._v("FAQs")])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-6bc54524", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6bc54524"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/portal/homeData/HomeIcons.vue
// module id = 537
// module chunks = 4